<template>
  <el-container class="ControlLayout aw ah">
    <el-header class="header">
      <GlobalTopNav :routes="routes" :teamEnable="teamEnable">
        <el-select
          slot="teamList"
          :popper-append-to-body="false"
          v-model="teamValue"
          placeholder="请选择"
          @change="dataRefresh"
        >
          <el-option
            v-for="item in teamOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
          <div class="TeamEnter" @click="goTeamManagement">
            <span>前往团队管理</span>
            <i class="el-icon-right"></i>
          </div>
        </el-select>
        <!-- <el-button
          slot="btn"
          @click="goHome"
          style="background: #373839 !important; border: 0 !important"
        >
          <svg
            class="home-btn"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
          >
            <use xlink:href="#icon-home1"></use>
          </svg>
          首页
        </el-button> -->
      </GlobalTopNav>
    </el-header>
    <el-main class="main">
      <transition name="el-fade-in-linear">
        <router-view />
      </transition>
    </el-main>
  </el-container>
</template>

<script>
import { MessageBox } from 'element-ui'
import GlobalTopNav from '@/components/GlobalTopNav/GlobalTopNav'
import routes from '../router/routes'
import { switchTeam, teamListSelect } from '@/api/teamManagement'
export default {
  name: 'ControlLayout',
  components: { GlobalTopNav },
  data () {
    return {
      routes: routes[2].children,
      teamOptions: [],
      teamValue: '',
      teamEnable: true
    }
  },
  computed: {
    name () {
      return this.data
    }
  },
  mounted () {
    this.getTeamListSelect()
  },
  methods: {
    goHome () {
      if (!this.teamEnable) {
        document.getElementsByClassName(
          'el-message-box__wrapper'
        )[0].style.top = '0px'
        document.getElementsByClassName('v-modal')[0].style.top = '0px'
        MessageBox.close()
      }
      this.$router.push('/home')
    },

    // 切换团队数据更新
    async dataRefresh (val) {
      await switchTeam({ teamId: val })
      await localStorage.setItem('teamId', val)
      this.$router.go(0)
    },

    // 初始化时获取下拉团队列表
    async getTeamListSelect () {
      const { data } = await teamListSelect()
      this.teamOptions = data

      this.$nextTick(() => {
        const tempId = Number(localStorage.getItem('teamId'))
        let includeTempId = false
        if (tempId) {
          data.forEach((v) => {
            if (v.id === tempId) {
              this.teamValue = v.id
              this.teamEnable = v.enable
              includeTempId = true
            }
          })
        }
        if (!includeTempId) {
          if (tempId) localStorage.removeItem('teamId')
          localStorage.setItem('teamId', data[0].id)
          this.teamValue = data[0].id
          this.teamEnable = data[0].enable
        }
        if (!this.teamEnable) this.teamEnableHandler()
      })
    },

    // 团队过期处理提示框展示
    teamEnableHandler () {
      if (
        !this.teamEnable &&
        document.getElementsByClassName('el-message-box__wrapper').length > 0
      ) {
        MessageBox.close()
      }
      this.$confirm('当前团队已过期, 是否立即续费', '提示', {
        showClose: false,
        closeOnClickModal: false,
        confirmButtonText: '续费',
        closeOnPressEscape: false,
        type: 'warning',
        showCancelButton: false,
        customClass: 'warning'
      })
        .then(() => {
          this.$router.push('/payManagement')
          document.getElementsByClassName(
            'el-message-box__wrapper'
          )[0].style.top = '0px'
          document.getElementsByClassName('v-modal')[0].style.top = '0px'
        })
        .catch(() => {})
      setTimeout(() => {
        document.getElementsByClassName(
          'el-message-box__wrapper'
        )[0].style.top = '47px'
        document.getElementsByClassName('v-modal')[0].style.top = '47px'
      })
    },

    // 前往团队管理
    async goTeamManagement () {
      if (!this.teamEnable) {
        await this.closeTeamDialog()
      }
      this.$router.push('/teamManagement')
    },

    // 团队过期处理提示框关闭
    closeTeamDialog () {
      document.getElementsByClassName('el-message-box__wrapper')[0].style.top =
        '0px'
      document.getElementsByClassName('v-modal')[0].style.top = '0px'
      MessageBox.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.ControlLayout {
  .el-header {
    height: 48px !important;
    background: #272829;
    box-sizing: border-box;
    border-bottom: 1px solid #000000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .home-btn {
      width: 16px;
      height: 16px;
      vertical-align: bottom;
    }
    .line {
      width: 1px;
      height: 28px;
      background: rgba(255, 255, 255, 0.1);
    }
    .left {
      .el-select {
        width: 200px;
      }
    }
    .center {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 10px;
      box-sizing: border-box;
      .nav {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.3);
        font-family: Source Han Sans SC;
        font-weight: 300;
        cursor: pointer;
        margin-left: 10px;
        transition: all 0.3s;
        &:hover {
          color: #ffffff;
        }
        &.active {
          color: #ffffff;
        }
      }
    }
    .right {
      width: 260px;
      height: 100%;
      padding-left: 57px;
      padding-right: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
    }
  }
  .el-main {
    background-color: #18191a;
    box-sizing: border-box !important;
    overflow: hidden;
    .page-bottom {
      position: absolute;
      height: 54px;
      width: 100%;
      bottom: 0px;
      left: 0px;
      padding: 0 32px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      font-size: 14px;
      .page-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .bottom-left {
          /*line-height: 1;*/
          .title {
            color: $font-color9;
          }
          .value {
            margin: 0px 10px;
            color: $font-colorf;
          }
        }
        .bottom-right {
          display: flex;
          align-items: center;
          .el-pagination {
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.header {
  height: 48px !important;
  width: 100%;
  background: #272829;
  box-sizing: border-box;
  border-bottom: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main {
  position: relative;
  overflow: hidden;
}
</style>
